import apiClient from './client'
import type { Material, CreateMaterialRequest, UpdateMaterialRequest, DeletedMaterial } from '../types/material'

export const materialsApi = {
  getByAssistantId: async (assistantId: string, category?: string): Promise<Material[]> => {
    const params = category ? { category } : {}
    const response = await apiClient.get<Material[]>(`/assistants/${assistantId}/materials`, { params })
    return response.data
  },

  getById: async (id: string): Promise<Material> => {
    const response = await apiClient.get<Material>(`/materials/${id}`)
    return response.data
  },

  create: async (assistantId: string, data: CreateMaterialRequest): Promise<Material> => {
    const response = await apiClient.post<Material>(`/assistants/${assistantId}/materials`, data)
    return response.data
  },

  update: async (id: string, data: UpdateMaterialRequest): Promise<Material> => {
    const response = await apiClient.put<Material>(`/materials/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/materials/${id}`)
  },

  /** Корзина направления: удалённые за 30 дней */
  trash: async (assistantId: string): Promise<DeletedMaterial[]> => {
    const response = await apiClient.get<{ materials: DeletedMaterial[] | null }>(`/assistants/${assistantId}/materials/trash`)
    return response.data?.materials ?? []
  },

  /** Вернуть из корзины (повтор - тот же материал) */
  restore: async (id: string): Promise<Material> => {
    const response = await apiClient.post<Material>(`/materials/${id}/restore`)
    return response.data
  },
}
